import React from 'react';

import {
  TemplateProfessionalExperienceItem,
  TemplateSection,
} from '@xing-com/crate-lebenslauf-components';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

export const useProfessionalInformation = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const { cv } = useReadVitaReactiveVariable();

  React.useEffect(() => {
    const professionalInformationList = cv?.professionalExperience;
    if (professionalInformationList) {
      const items = professionalInformationList?.map(
        (professionalInformation, itemIndex) => (
          <TemplateProfessionalExperienceItem
            key={`professional-` + itemIndex}
            $margin="0 0 15px 0"
            {...professionalInformation}
          />
        )
      );

      setData(
        items.length > 0
          ? [
              <div key="professionalInformationHeader">
                <TemplateSection name="career" />
                {items[0]}
              </div>,
              ...items.slice(1),
            ]
          : []
      );
    }
  }, [cv?.professionalExperience]);

  return data;
};
